import React, {Component} from 'react';
import {SESSION_USER,API_BASE_URL} from '../../constants';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import Loading from '../../common/Loading';
import $ from 'jquery';
import 'dropify';
import 'dropify/dist/css/dropify.css';
import 'jquery-asColorPicker';
import {getAllTimeZones,insertOrUpdateSetting,getSettingByUserId} from '../../util/APIUtils';

import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField, selectField} from '../../helpers/Error';
import 'timepicker';
import 'timepicker/dist/jquery.timepicker.css'
const validate = (values, props) => {
	 const errors = {};
	    if (!values.zohoCreatorToken) {
	        errors.zohoCreatorToken = 'Zoho Creator Token field required'
	    }
	    if (!values.zcApplicationName) {
	        errors.zcApplicationName = 'Zoho Application Name field required'
	    }
	    if (!values.zcOwnername) {
	        errors.zcOwnername = 'Zoho Owner name field required'
	    }
	    return errors;
};
class settingForm extends React.Component {
    componentDidMount(){
      $('#basicExample .time').timepicker({
            showDuration: true,
            template : false,
            showInputs : false,
            minuteStep : 5,
            timeFormat: 'g:i A'
        });
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit} name="settingform" id="settingform">
                <div className="card-body">


                    <div className="form-body">
                        <div className="row p-t-20">

                            <div className="col-md-6">

                                <UploadForm  onFileChange={this.props.changeFile} companyLogo={this.props.states.companyLogo}/>

                            </div>
                        </div>

                        <div className="row" style={{display:'none'}}>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Email Notification</label>
                                    <Field valueKey="value" options={settingswitch}
                                           value={this.props.states.emailNotification} name="emailNotification"
                                           component={selectField}
                                            onChange={(e) => this.props.selectChange("emailNotification", e)}/>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Default Timed Event Duration (hr)</label>
                                    <Field valueKey="value" options={default_event_duration}
                                           value={this.props.states.defaultEventDuration} name="defaultEventDuration"
                                           component={selectField}
                                          onChange={(e) => this.props.selectChange("defaultEventDuration", e)}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Timezone</label>
                                <Field valueKey="value" options={this.props.states.optionTimezoneList}
                                       value={this.props.states.timezone} name="timezone"
                                       component={selectField}
                                       onChange={(e) => this.props.selectChange("timezone", e)}/>
                            </div>
                        </div>

                        </div>

                        <div className="row">
                           

                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Travel Event Color</label>
                                    <Field type="text" className="form-control colorpicker" id="travelEventBgColor" name="travelEventBgColor"
                                           fieldValue={this.props.states.travelEventBgColor}
                                           component={inputField}
                                           onChange={this.props.changeState}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                             <div className="col-md-6">
                              
		                                      <div className="form-group">
			                                       <label className="control-label">Working From Time</label>
			                                       <Field type="time"   style={{width: '100%'}} placeholder="00:00 AM/PM"  className="form-control time1" id="fromtime" name="fromtime"
			                                           fieldValue={this.props.states.fromtime}
			                                           component={inputField}
			                                           onChange={this.props.changeState}/>
		                                       </div>
	                          </div>
	                          <div className="col-md-6">
		                              <div className="form-group">
		                                  <label className="control-label">Working To Time</label>
		                                     <Field type="time"   style={{width: '100%'}} placeholder="00:00 AM/PM"  className="form-control time1" id="totime" name="totime"
		                                      fieldValue={this.props.states.totime}
		                                      component={inputField}
		                                      onChange={this.props.changeState}/>
		                              </div>
                              </div>
	                    </div> 
	                    
	                    <div className="row">
			                        <div className="col-md-6">

			                        <div className="form-group">
		                                <label className="control-label">Zoho CreatorToken </label>
		                                <Field type="text" className="form-control" name="zohoCreatorToken"
		                                       fieldValue={this.props.states.zohoCreatorToken}
		                                       component={inputField}
		                                       onChange={this.props.changeState}/>
	                                 </div>
			                  
			                        </div>
			                        <div className="col-md-6">
					                      
			                        </div>
	                    </div> 
	                    <div className="row">
                        <div className="col-md-6">
                        <div className="form-group">
                        <label className="control-label">Zoho Application Name </label>
                        <Field type="text" className="form-control" name="zcApplicationName"
                               fieldValue={this.props.states.zcApplicationName}
                               component={inputField}
                               onChange={this.props.changeState}/>
                     </div>
                        
                        </div>
                        </div> 
	                    <div className="row">
	                        <div className="col-md-6">
				                        <div className="form-group">
			                            <label className="control-label">Zoho Owner Name </label>
			                            <Field type="text" className="form-control" name="zcOwnername"
			                                   fieldValue={this.props.states.zcOwnername}
			                                   component={inputField}
			                                   onChange={this.props.changeState}/>
			                         </div>
	                        </div>
	                        <div className="col-md-6">
	                        
	                        </div>
                       </div>  
                          <h3 className="box-title m-t-40">Company Working Time</h3>
                    <hr/>


                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Monday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="monday_start_time" name="monday_start_time"
                                               fieldValue={this.props.states.monday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="monday_end_time" name="monday_end_time"
                                               fieldValue={this.props.states.monday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Tuesday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="tuesday_start_time" name="tuesday_start_time"
                                               fieldValue={this.props.states.tuesday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="tuesday_end_time" name="tuesday_end_time"
                                               fieldValue={this.props.states.tuesday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Wednesday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="wednesday_start_time" name="wednesday_start_time"
                                               fieldValue={this.props.states.wednesday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                           <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="wednesday_end_time" name="wednesday_end_time"
                                               fieldValue={this.props.states.wednesday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Thursday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="thursday_start_time" name="thursday_start_time"
                                               fieldValue={this.props.states.thursday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="thursday_end_time" name="thursday_end_time"
                                               fieldValue={this.props.states.thursday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Friday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="friday_start_time" name="friday_start_time"
                                               fieldValue={this.props.states.friday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="friday_end_time" name="friday_end_time"
                                               fieldValue={this.props.states.friday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Saturday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="saturday_start_time" name="saturday_start_time"
                                               fieldValue={this.props.states.saturday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="saturday_end_time" name="saturday_end_time"
                                               fieldValue={this.props.states.saturday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>

                     <div className="row">
                            <div className="col-md-6">

                                  <div> <div style={{float:'left',padding:'6px'}} ><label className="control-label">Sunday</label></div>&nbsp;
                                      
                                           <div style={{float:'left'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="sunday_start_time" name="sunday_start_time"
                                               fieldValue={this.props.states.sunday_start_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                          </div>

                                         <div style={{float:'left',paddingLeft:'15px'}}>
                                              <Field type="time"   style={{width: '120px'}} placeholder="00:00"  className="form-control" id="sunday_end_time" name="sunday_end_time"
                                               fieldValue={this.props.states.sunday_end_time}
                                               component={inputField}
                                               onChange={this.props.changeState}/>
                                           </div>
                                     </div>

                                </div>
                     </div>
	                                     
                    </div>
                <input type="hidden" name="id" id="id" value={this.props.states.id}/>
                <div className="form-actions">
                    <button type="submit" className="btn btn-primary btn-rounded"><i className="fa fa-check"></i> Save</button>
                    &nbsp;&nbsp;&nbsp;
                    <a href="/schedule" className="btn btn-inverse btn-rounded">Cancel</a>
           
                </div>
                </div>
            </form>
        );
    }
}

const SettingForm = reduxForm({
    form: 'settings_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    updateUnregisteredFields: true,
    validate
})(settingForm);


const default_event_duration = [
  {
    "label": "00:30",
    "value": "00:30"
  },
  {
    "label": "01:00",
    "value": "01:00"
  },
  {
    "label": "01:30",
    "value": "01:30"
  },
  {
    "label": "02:00",
    "value": "02:00"
  },
  {
    "label": "02:30",
    "value": "02:30"
  },
  {
    "label": "03:00",
    "value": "03:00"
  }
];
const settingswitch = [
  {
    "label": "Disable",
    "value": "disable"
  },
  {
    "label": "Enable",
    "value": "enable"
  }
];
export default class Setting extends Component {

    constructor(props) {
        super(props);
        this.state = {
                id: '' ,
                timezone: '',
                defaultEventDuration:'',
                emailNotification:'',
                travelEventBgColor:'',
                optionTimezoneList:[],
                file:'',
                fromtime:'',
                totime:'',
                 monday_start_time:'09:00',
                  monday_end_time:'18:00',
                  tuesday_start_time:'09:00',
                  tuesday_end_time:'18:00',
                  wednesday_start_time:'09:00',
                  wednesday_end_time:'18:00',
                  thursday_start_time:'09:00',
                  thursday_end_time:'18:00',
                  friday_start_time:'09:00',
                  friday_end_time:'18:00',
                  saturday_start_time:'09:00',
                  saturday_end_time:'18:00',
                  sunday_start_time:'09:00',
                  sunday_end_time:'18:00',
                loading: true
        }
        this.timezonelist = this.timezonelist.bind(this);
        this.loadsetting = this.loadsetting.bind(this);
        this.onSubmit=this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.changeFile= this.changeFile.bind(this);
           this.isStartTimeNull= this.isStartTimeNull.bind(this);
        this.isEndTimeNull= this.isEndTimeNull.bind(this);
    }
    componentDidMount() {
           this.timezonelist();
           this.loadsetting();    
    }

       isStartTimeNull(weekHours,dayOfweek){
         if(weekHours && weekHours[dayOfweek]){
            return weekHours[dayOfweek].start_time;
         }
         return '08:00'; 
    }


    isEndTimeNull(weekHours,dayOfweek){
         if(weekHours && weekHours[dayOfweek]){
            return weekHours[dayOfweek].end_time;
         }
         return '18:00'; 
    }


    onSubmit(values, dispatch){
            let fields = values;
            let user = JSON.parse(localStorage.getItem(SESSION_USER));
            fields["userId"] = user.id;
            console.log('fields',fields);
            
            if (fields['timezone']) {
                fields['timezone'] = fields['timezone'].value;
            }
            if (fields['defaultEventDuration']) {
                 fields['defaultEventDuration'] = fields['defaultEventDuration'].value;
            }


            if (fields['emailNotification']) {
                fields['emailNotification'] = fields['emailNotification'].value;
            }

            fields['travelEventBgColor']= $('#travelEventBgColor').val();

      console.log(fields);
      
     // return false;
      const formData = new FormData();
    
      

      if(fields){
        for(var k in fields){
           var field= fields[k];
            formData.append(k,field);
        }
      }

     if(this.state.file){
         formData.append('file',this.state.file);
      }else{
         formData.delete('file');
      }

      insertOrUpdateSetting(formData)
            .then(response => {
              window.location.href='/settings';
            //    this.props.history.push("/settings");
            }).catch(error => {
            this.setState({
                serverError: true,
            });
        })

    }

     loadsetting() {
      let user = JSON.parse(localStorage.getItem(SESSION_USER));
        getSettingByUserId(user.id)
            .then(response => {
               console.log(response);

                var emailNotificationLabel='';
                 if(response.emailNotification==='disable'){
                     emailNotificationLabel='Disable';
                 }else{
                    emailNotificationLabel='Enable';
                 }
                 this.setState({
                    id:response.id,
                    companyLogo:response.companyLogo,
                    timezone:{label: response.timezone, value: response.timezone},
                    defaultEventDuration:{label: response.defaultEventDuration, value: response.defaultEventDuration},
                    emailNotification:{label: emailNotificationLabel, value: response.emailNotification},
                    travelEventBgColor:response.travelEventBgColor,
                    fromtime:response.fromtime,
                    totime:response.totime,
                    zohoCreatorToken:response.zohoCreatorToken,
                    zcApplicationName:response.zcApplicationName,
                    zcOwnername:response.zcOwnername,
                     monday_start_time:this.isStartTimeNull(response.weekHours,1),
                    monday_end_time:this.isEndTimeNull(response.weekHours,1),
                    tuesday_start_time:this.isStartTimeNull(response.weekHours,2),
                    tuesday_end_time:this.isEndTimeNull(response.weekHours,2),
                    wednesday_start_time:this.isStartTimeNull(response.weekHours,3),
                    wednesday_end_time:this.isEndTimeNull(response.weekHours,3),
                    thursday_start_time:this.isStartTimeNull(response.weekHours,4),
                    thursday_end_time:this.isEndTimeNull(response.weekHours,4),
                    friday_start_time:this.isStartTimeNull(response.weekHours,5),
                    friday_end_time:this.isEndTimeNull(response.weekHours,5),
                    saturday_start_time:this.isStartTimeNull(response.weekHours,6),
                    saturday_end_time:this.isEndTimeNull(response.weekHours,6),
                    sunday_start_time:this.isStartTimeNull(response.weekHours,0),
                    sunday_end_time:this.isEndTimeNull(response.weekHours,0),
                    loading: false
                 });

            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
     }

      timezonelist() {

        getAllTimeZones()
            .then(response => {
                var timzonearray = [];
                for (var k in response) {
                    timzonearray.push({label: response[k], value: response[k]})
                }
                this.setState({optionTimezoneList: timzonearray});

               // console.log(timzonearray);
            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
    }


  
      changeFile(e) {
           this.setState({file: e.target.files[0]});
      }

    onSelectChange(name,value) {
        const target = value;
        console.log(name);
            console.log(value);
       
        if (!this.state.loading) {
            this.setState({name: target});
        }

    }
 
    handleChange(event) {
       
        const target = event.target;   
        const inputValue = target.value;
        this.setState({
            [target.name] : inputValue
        });


    }

    

	  render(){
      
       if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.loading) {
           return <Loading />;
        } 


    return (
         <div>
     
               <div className="row">
                    <div className="col-8">
                        <div className="card card-outline-info">
                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Settings form</h4>
                            </div>
                            <Provider store={Store}>
                                <SettingForm changeState={this.handleChange} states={this.state} initialValues={this.state} selectChange={this.onSelectChange}
                                         onSubmit={this.onSubmit.bind(this)}   changeFile={this.changeFile}/>
                            </Provider>
                          

                        </div>
                     </div> 
                  </div>   
                  </div>   
          );
  }

 
}

class UploadForm extends Component {
    componentDidMount() {
        $('.dropify').dropify();
        $(".colorpicker").asColorPicker({mode: 'simple'});
    }

    render() {

      let user = JSON.parse(localStorage.getItem(SESSION_USER));
      const companyLogo = this.props.companyLogo;
      var filePath='../static/assets/images/people.png'; 
       if(companyLogo){
           filePath=API_BASE_URL+'/image/user/'+user.id+'/profileimage.jpg';
       }
        return (

            <div className="form-group">

                <label htmlFor="input-file-now-custom-1">Company Logo</label>
              
               
              
                <input type="file" onChange={this.props.onFileChange} id="input-file-now-custom-1" accept="image/*" name="file" className="dropify"
                       data-height="75" data-max-file-size="1M" data-default-file={filePath}/>

                

            </div>

        );
    }

}